import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import { Link } from 'react-router-dom'
import { colors } from '../../../theme/palette'
import { useWindowResize } from '../../../hooks/useWindowSize'
import breakpoints from '../../../theme/breakpoints'

type RuleNames = 'row'

interface StyleProps {
    gridTemplateColumns?: string
}

interface CardMobileProps {
    url?: string | undefined
    gridTemplateColumns?: string
    onClick?: () => void
}

const useStyles = createUseStyles<RuleNames, StyleProps, Jss.Theme>(() => ({
    row: ({ gridTemplateColumns }) => {
        return {
            position: 'relative',
            backgroundColor: colors.white,
            width: '100%',
            color: 'black',
            marginBottom: '1rem',
            display: 'grid',
            gridTemplateColumns,
            padding: '10px',
        }
    },
}))

const CardMobile: React.FC<CardMobileProps> = ({
    url,
    gridTemplateColumns,
    onClick,
    children,
}) => {
    const theme = useTheme<Jss.Theme>()
    const classes = useStyles({ ...{ gridTemplateColumns }, theme })
    const windowSize = useWindowResize()

    if (windowSize.width < breakpoints.Desktop) {
        if (url) {
            return (
                <Link tabIndex={0} className={`${classes.row}`} to={url}>
                    {children}
                </Link>
            )
        }

        return (
            <div
                className={classes.row}
                onClick={onClick && onClick}
                role="button"
                tabIndex={-1}
                onKeyDown={onClick}
            >
                {children}
            </div>
        )
    }

    return null
}

CardMobile.defaultProps = {
    gridTemplateColumns: '20% 80%',
}

export { CardMobile }
